/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Status_ReadyInputs */

const en_mcp_cap_status_ready = /** @type {(inputs: Mcp_Cap_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to listen`)
};

const es_mcp_cap_status_ready = /** @type {(inputs: Mcp_Cap_Status_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo para escuchar`)
};

/**
* | output |
* | --- |
* | "Ready to listen" |
*
* @param {Mcp_Cap_Status_ReadyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_status_ready = /** @type {((inputs?: Mcp_Cap_Status_ReadyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Status_ReadyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_status_ready(inputs)
	return en_mcp_cap_status_ready(inputs)
});